export const Toggle = {
	toggleTrackFill: 'var(--epods--color-bg-toggle-off)',
	toggleTrackFillDisabled: 'var(--epods--color-bg-toggle-off-disabled)',
};

export const CustomToggle = {
	toggleTrackHover: 'var(--epods--color-bg-toggle-off-hover)',
	toggleTrackCheckedHover: 'var(--epods--color-bg-primary-hover)',
	toggleTrackErrorHover: 'var(--epods--color-bg-toggle-off-hover)',
	toggleTrackErrorBorder: 'var(--epods--color-bg-toggle-error)',
	toggleCircleErrorHoverBorder: 'var(--epods--color-text-inverted)',
	toggleTrackErrorHoverBorder: 'var(--epods--color-bg-toggle-off-hover)',
	toggleTrackErrorChecked: 'var(--epods--color-bg-toggle-error)',
	toggleTrackErrorCheckedHover: 'var(--epods--color-bg-toggle-error-hover)',
	toggleTrackDisabledChecked: 'var(--epods--color-bg-primary-disabled)',
	toggleCircleBackground: 'var(--epods--color-text-inverted)',
};
